import { FrownOutlined } from '@ant-design/icons';
import axios from 'axios';
import { envApiUrl } from '../../fetchHooks/envApiUrl';
import { openNotification } from './openNotification';

interface SignupData {
  firstname: string;
  lastname: string;
  hourRate: number;
  email: string;
  password: string;
  username: string;
  role: string;
}

export const handleSignup = async (data: SignupData) => {
  const csrfResponse = await axios.get(envApiUrl + '/auth/csrf-token', {
    withCredentials: true,
  });
  const csrfToken = csrfResponse.data.csrfToken;
  try {
    const response = await axios.post(envApiUrl + '/auth/signup', data, {
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken,
      },
      withCredentials: true,
      xsrfCookieName: 'csrftoken',
      xsrfHeaderName: 'x-csrf-token',
    });
    return response.data;
  } catch (error) {
    console.error('Signup error: ', error);
    openNotification('Error', error instanceof Error ? error.message : 'An unknown error occurred', <FrownOutlined />);
    throw error;
  }
};
